<template>
  <div class="box">
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <div class="control">
            <label class="label">{{ $t("section name") }}</label>
            <input
              class="input"
              type="text"
              v-model="meta.section_name"
              :placeholder="$t('section name')"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <generic-dropdown
          :title="$t('pensum')"
          :placeholder="$t('pensum')"
          url="/student/pensum/catalog"
          name_field="name"
          value_field="period_id"
          :extra_data="{
            program_id: $props.group.program_id,
            stage_id: $props.group.stage_id,
          }"
          @selected="set_pensum"
          ref="pensum_dropdown"
          :is_multiple="false"
        />
      </div>
    </div>

    <div class="columns">
      <div class="column is-4">
        <div class="title is-5">{{ $t("student list") }}</div>
        <table class="table">
          <thead>
            <tr>
              <th>{{ $t("student") }}</th>
              <th>{{ $t("id") }}</th>
              <!-- <th>{{ $t("actions") }}</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(itm, key) in $props.students" :key="key">
              <td>{{ `${itm.student.first_name} ${itm.student.surname}` }}</td>
              <td>{{ itm.student.id_card_number }}</td>
              <!-- <td>
            <div class="buttons">
              <button class="button is-rounded is-danger">
                <span class="icon">
                  <i class="fa fa-trash"></i>
                </span>
              </button>
            </div>
          </td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="column">
        <table class="table" v-show="courses.length">
          <thead>
            <tr>
              <th>{{ $t("course") }}</th>
              <th>{{ $t("classroom") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(itm, key) in courses" :key="key">
              <td>{{ itm.course.name }}</td>
              <td>
                <generic-dropdown
                  :add_new="true"
                  :show_title="false"
                  :placeholder="$t('select one')"
                  url="/student/classroom/catalog"
                  :display_function="
                    (
                      itm
                    ) => `<div class='title is-6'>${itm.professor.first_name} ${itm.professor.first_surname}</div>
                    <div class='subtitle is-7'>${itm.course.name}</div>`
                  "
                  value_field="classroom_id"
                  @selected="set_classroom(key, $event)"
                  ref="classroom_dropdown"
                  :is_multiple="false"
                  :extra_data="{
                    period_id: $props.period_id,
                    course_id: itm.course.course_id,
                  }"
                  @add_new="new_classroom(itm)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <button class="button is-primary" :disabled="is_form_invalid" @click="save">
      <span class="icon"><i class="fa fa-save"></i></span>
      <span>{{ $t("save") }}</span>
    </button>

    <!-- <pre>{{ $props.students }}</pre> -->
    <classroom-modal ref="classroom_modal" />
  </div>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import ClassroomModal from "../../classrooms/classroom_modal/Index.vue";

export default {
  name: "StudentSection",
  components: { GenericDropdown, ClassroomModal },
  data() {
    return {
      meta: {},
      error: "",
      courses: [],
    };
  },
  props: {
    students: {
      type: Object,
      required: true,
    },
    group: {
      type: Object,
      required: true,
    },
    period_id: {
      type: Number,
      required: true,
    },
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.section_name;
    },
    pensum_list() {
      let v = this;
      if (v.$props.students && v.$props.students.length) {
        let first_student = v.$props.students[0];
        let pensum_list = first_student.program.student_pensums;
        return pensum_list;
      } else {
        return [];
      }
    },
  },
  methods: {
    save() {
      let v = this;
      // console.log("saving section", v.meta, v.$props.students);
      v.$root.loader(true);
      post("/student/section", {
        ...v.meta,
        period_id: v.$props.period_id,
        program_id: v.$props.group.program_id,
        stage_id: v.$props.group.stage_id,
        inscriptions: v.$props.students.map((s) => s.inscription_id),
        classrooms: v.courses.map((c) => c.classroom_id),
      })
        .then(() => {
          v.$emit("section-saved");
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    set_pensum(pensum) {
      let v = this;
      if (pensum) {
        v.courses = pensum.student_pensum_courses;
      }
    },
    set_teacher(key, teacher) {
      let v = this;
      if (teacher) {
        v.courses[key].teacher_id = teacher.member_id;
      }
    },
    set_classroom(key, classroom) {
      let v = this;
      if (classroom) {
        v.courses[key].classroom_id = classroom.classroom_id;
      }
    },
    new_classroom(key) {
      let v = this;
      console.log("new classroom", key);
      v.$refs.classroom_modal.create({
        period_id: v.$props.period_id,
        course_id: key.course.course_id,
      });
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
